module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<button id=\"new-posts\" class=\"btn new-posts visually-hidden\" data-scroll-to-new-posts type=\"button\"> <%- copy.buttons.new_posts.copy.button_text %> </button> <ul id=\"feed-container\" class=\"tile-list-wrapper\" role=\"feed\" aria-busy=\"false\" data-feed></ul> <% if(displayLoadMoreButton) { %> <button class=\"btn load-more\" data-load-more-posts type=\"button\"> <%- copy.buttons.load_more.copy.button_text%> </button> <% } %> "
  , __filename = undefined;
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<button id=\"new-posts\" class=\"btn new-posts visually-hidden\" data-scroll-to-new-posts type=\"button\"> ")
    ; __append( copy.buttons.new_posts.copy.button_text )
    ; __append(" </button> <ul id=\"feed-container\" class=\"tile-list-wrapper\" role=\"feed\" aria-busy=\"false\" data-feed></ul> ")
    ;  if(displayLoadMoreButton) { 
    ; __append(" <button class=\"btn load-more\" data-load-more-posts type=\"button\"> ")
    ; __append( copy.buttons.load_more.copy.button_text)
    ; __append(" </button> ")
    ;  } 
    ; __append(" ")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

}